const browserDocument = () => (
  typeof document !== 'undefined' ? document : null
);

/**
 * Render menus outside scroll/overflow containers while keeping positioning
 * tied to the control. Call this while rendering so hydration can resolve the
 * browser document safely.
 */
export const getPortalSelectProps = () => ({
  menuPlacement: 'auto',
  menuPosition: 'fixed',
  menuPortalTarget: browserDocument()?.body,
  menuShouldScrollIntoView: false,
});

/**
 * Presentation contract for long account/location selectors. Compact selects
 * can opt into only getPortalSelectProps and keep their existing dimensions.
 */
export const getEntitySelectProps = () => ({
  ...getPortalSelectProps(),
  className: 'mvp-entity-select',
  classNamePrefix: 'mvp-entity-select',
});
